export enum ProductInfo {
  CompanyName = 'Customis3d Ltd',
  Address = 'The Limes, Bayshill rd, GL50 3AW, Cheltenham, Gloucestershire, United Kingdom',
  Email = 'contact@customis3d.app',
}
